<button mat-icon-button [matMenuTriggerFor]="menu" data-cy="add-to-queue" class="gh-button" (menuOpened)="handleOpened()" (menuClosed)="handleClosed()"><mat-icon>queue</mat-icon></button>

<mat-menu #menu="matMenu" class="gh-menu">
  <mat-card (click)="$event.stopPropagation()">
    <mat-card-header data-cy="add-to-queue-menu" class="tw-items-center">
      <mat-icon mat-card-avatar>queue</mat-icon>
      <mat-card-title data-cy="add-to-queue-header">Add to Queue</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="handleSubmit($event)">
        <mat-form-field>
          <mat-label>Borrower IDs (one per line)</mat-label>
          <textarea
            #focus
            data-cy="borrowerId-input"
            matInput
            formControlName="borrowerIds"
            name="borrowerIds"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="10"
            required></textarea>
          <mat-error *ngIf="borrowerIds && borrowerIds.errors && borrowerIds.errors.pattern">IDs must be numeric, one per line</mat-error>
        </mat-form-field>
      </form>
    </mat-card-content>
    <mat-card-footer style="border: 0 none; padding-top: 0;">
      <button data-cy="save-btn" mat-flat-button color="primary" [disabled]="!form.valid || processing" (click)="handleSubmit($event)">
        <span *ngIf="!processing">Save</span>
        <mat-spinner *ngIf="processing" diameter="24" style="display: inline-block; height: 24px; width: 24px"></mat-spinner>
      </button>
    </mat-card-footer>
  </mat-card>
  <mat-progress-bar *ngIf="processing" mode="determinate" [value]="(completed / total) * 100"></mat-progress-bar>
</mat-menu>
